/* Oontly product page: gallery, variant selection, bundle tiers.
   Without JS the page still works: a plain add-to-cart form at quantity 1. */
(function () {
  function money(cents, symbol) { return symbol + (cents / 100).toFixed(2); }

  function initGallery(root) {
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-oo-shot]'));
    if (!shots.length) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-oo-thumb]'));
    var count = root.querySelector('[data-oo-count]');
    var i = 0;

    function show(n) {
      i = (n + shots.length) % shots.length;
      shots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + shots.length;
    }
    root.gallerySkipTo = function (mediaId) {
      for (var k = 0; k < shots.length; k++) {
        if (shots[k].getAttribute('data-media-id') === String(mediaId)) { show(k); return; }
      }
    };

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-oo-gprev]'), next = root.querySelector('[data-oo-gnext]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    var main = root.querySelector('[data-oo-gal]'), startX = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 42) show(i + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    show(0);
  }

  function initBuy(root) {
    var dataEl = root.querySelector('[data-oo-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    if (!variants.length) return;
    var symbol = root.getAttribute('data-oo-symbol') || '$';
    var idInput = root.querySelector('[data-oo-vid]');
    var qtyInput = root.querySelector('[data-oo-qty]');
    var priceEl = root.querySelector('[data-oo-price]');
    var stockEl = root.querySelector('[data-oo-stock]');
    var ctaEl = root.querySelector('[data-oo-cta]');
    var buyEl = root.querySelector('[data-oo-buy]');
    var addForm = root.querySelector('[data-oo-form]');
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-oo-bundle]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-oo-pill]'));
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-oo-opt]'));
    var selected = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var qty = 1, off = 0, code = '';

    function chosenOptions() {
      var chosen = [];
      selects.forEach(function (el) { chosen[Number(el.getAttribute('data-oo-opt'))] = el.value; });
      pills.forEach(function (el) {
        if (el.getAttribute('aria-pressed') === 'true') chosen[Number(el.getAttribute('data-oo-index'))] = el.getAttribute('data-oo-value');
      });
      return chosen;
    }

    function pickVariant() {
      var chosen = chosenOptions();
      if (!chosen.length) return selected;
      var match = variants.filter(function (v) {
        for (var k = 0; k < chosen.length; k++) {
          if (chosen[k] != null && v.options[k] !== chosen[k]) return false;
        }
        return true;
      })[0];
      return match || selected;
    }

    function render() {
      if (idInput) idInput.value = selected.id;
      if (qtyInput) qtyInput.value = qty;
      if (priceEl) priceEl.textContent = money(selected.price, symbol);
      if (stockEl) stockEl.textContent = selected.available ? 'In stock · ships from the US' : 'Out of stock';

      bundles.forEach(function (b) {
        var n = Number(b.getAttribute('data-oo-n')) || 1;
        var pct = Number(b.getAttribute('data-oo-off')) || 0;
        var list = selected.price * n, total = Math.round(list * (1 - pct / 100));
        var tEl = b.querySelector('[data-oo-total]'), sEl = b.querySelector('[data-oo-list]'), saveEl = b.querySelector('[data-oo-save]');
        if (tEl) tEl.textContent = money(total, symbol);
        if (sEl) sEl.textContent = money(list, symbol);
        if (saveEl) saveEl.textContent = 'save ' + money(list - total, symbol);
        b.setAttribute('aria-checked', n === qty ? 'true' : 'false');
      });

      var list = selected.price * qty, total = Math.round(list * (1 - off / 100));
      if (ctaEl) ctaEl.textContent = 'Add to cart · ' + money(total, symbol);
      if (addForm) addForm.style.display = selected.available ? '' : 'none';
      if (buyEl) {
        var permalink = '/cart/' + selected.id + ':' + qty;
        buyEl.setAttribute('href', code ? '/discount/' + code + '?redirect=' + encodeURIComponent(permalink) : permalink);
        buyEl.style.display = selected.available ? '' : 'none';
      }
      selects.forEach(function (el) {
        var k = Number(el.getAttribute('data-oo-opt'));
        if (selected.options[k]) el.value = selected.options[k];
      });
      pills.forEach(function (p) {
        var k = Number(p.getAttribute('data-oo-index'));
        p.setAttribute('aria-pressed', p.getAttribute('data-oo-value') === selected.options[k] ? 'true' : 'false');
      });
      if (selected.featured_media && root.gallerySkipTo) root.gallerySkipTo(selected.featured_media.id);
    }

    selects.forEach(function (el) {
      el.addEventListener('change', function () { selected = pickVariant(); render(); });
    });
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (o) {
          if (o.getAttribute('data-oo-index') === p.getAttribute('data-oo-index')) {
            o.setAttribute('aria-pressed', o === p ? 'true' : 'false');
          }
        });
        selected = pickVariant();
        render();
      });
    });
    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Number(b.getAttribute('data-oo-n')) || 1;
        off = Number(b.getAttribute('data-oo-off')) || 0;
        code = b.getAttribute('data-oo-code') || '';
        render();
      });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-oo-product]').forEach(function (root) {
      initGallery(root);
      initBuy(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
